export const HeadingStyle = {
  baseStyle: {
    fonts: 'Work Sans',
    fontWeight: 600,
    color: 'BLACK',
  },
  variants: {
    b36: {
      fontSize: 36,
      lineHeight: 1,
      marginBottom: '2px',
    },
    b26: {
      fontSize: 26,
      lineHeight: 1,
      marginBottom: '2px',
    },
    b18: {
      fontSize: 18,
    },
    b16: {
      fontSize: 16,
    },
    b14: {
      fontSize: 14,
    },
    b12: {
      fontSize: 12,
    },
    sectionHeading: {
      fontSize: [26, null, 36],
      lineHeight: [1.2, null, 1],
      marginBottom: ['4px', null, '8px'],
      color: 'BLACK',
    },
    elementHeading: {
      fontSize: [26, null, 36],
      lineHeight: [1.2, null, 1],
      marginBottom: ['4px', null, '8px'],
      color: 'BLACK',
    },
    // field: {
    //   fontSize: [16],
    // },
    navMenu: {
      fontSize: 16,
      fontWeight: 600,
      color: 'WHITE',
      textTransform: 'uppercase',
      textDecoration: 'none',
      padding: '0 10px',
      _hover: {
        textDecoration: 'none',
      },
    },
    navActions: {
      fontSize: 16,
      fontWeight: 600,
      color: 'inherit',
      textTransform: 'uppercase',
      textDecoration: 'none',
      padding: '0 10px',
    },
    footer: {
      fontSize: 12,
      fontWeight: 600,
      color: 'GRAY_DARK',
    },
    linkIcon: {
      color: 'NAVY',
      fontSize: 14,
      fontWeight: 500,
    },
    jobTitle: {
      fontSize: '18px',
      fontWeight: 700,
      textTransform: 'uppercase',
      paddingBottom: '4px',
    },
  },
};
